import React from 'react';

import LoadingScreen from '@asteria/layout/loading';

import { useLoading } from '../../hooks';

const ForecasterLoader = () => {
	const loading = useLoading();

	if (loading === 'integration') {
		return <LoadingScreen blur type="forecaster.loading.integration" />;
	}

	return null;
};

export default ForecasterLoader;
